export default __webpack_public_path__ + "static/media/phone-solid-blue.b71fff48.svg";